import { i18n } from "@lingui/core";
import { I18nProvider } from "@lingui/react";
import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { config } from "./config/env";
import { messages as deMessages } from "./locales/de/messages.mjs";
import { messages as enMessages } from "./locales/en/messages.mjs";
import "./theme/fonts.css";
import "./theme/print.css";

if (config.sentryDsn) {
  Sentry.init({
    dsn: config.sentryDsn,
    integrations: [Sentry.browserTracingIntegration()],
    environment: config.sentryEnvironment,
    tracesSampleRate: config.sentryTracesSampleRate,
  });
}

i18n.load("en", enMessages);
i18n.load("de", deMessages);
i18n.activate("en");

ReactDOM.createRoot(document.getElementById("root")!).render(
  <I18nProvider i18n={i18n}>
    <App />
  </I18nProvider>,
);
